import AuthService from './AuthService';
import ApiService from "./ApiService";

class ProductsService extends ApiService{
    constructor(authService) {
        super();
        this._authService = authService;
        this._locale = 'ru';
        this._initialUrl = '/products/initial';
        this._createProductUrl = '/products/create';
        this._productsUrl = '/products';
        this._deleteUrl = '/products/delete';
        this._deleteMultipleUrl = '/products/delete-multiple';
        this._deleteImageUrl = '/products/delete/image';
        this._tableDataUrl = '/products/table-data';
        this._updateUrl = '/products/update/'
    }


    getBaseHeaders() {
        const langHeader = this._locale ? {'X-Localization' : this._locale} : {};
        const authHeader = this._authService.getAuthHeader();

        return {...authHeader, ...langHeader};
    }

    create(data) {
        const headers = {...this.getBaseHeaders(), 'Content-Type': 'multipart/form-data'};
        return this.postResource(this._createProductUrl, data, headers);
    }

    getProducts(params) {
        return this.postResource(this._productsUrl, params, this.getBaseHeaders())
    }

    getInitial(id) {
        return this.postResource(this._initialUrl, {id}, this.getBaseHeaders())
    }

    getTableData() {
        return this.postResource(this._tableDataUrl, {}, this.getBaseHeaders())
    }

    delete(id) {
        return this.postResource(this._deleteUrl, {id}, this.getBaseHeaders())
    }

    deleteMultiple(IDs) {
        return this.postResource(this._deleteMultipleUrl, {IDs: IDs}, this.getBaseHeaders())
    }

    removeProductImage(params) {
        return this.postResource(this._deleteImageUrl, params, this.getBaseHeaders());
    }

    updateParam(param, data) {
        const url = this._updateUrl + param;

        return this.postResource(url, data, this.getBaseHeaders());
    }

    updateProduct(data) {
        const headers = {...this.getBaseHeaders(), 'Content-Type': 'multipart/form-data'};
        return this.postResource(this._updateUrl, data, headers);
    }
}

const service = new ProductsService(AuthService);

export default service;
